import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";

interface SmallTextProps
  extends HTMLAttributes<HTMLElement>,
    CommonComponentProps {}

export function SmallText({ children, className, ...rest }: SmallTextProps) {
  return (
    <small
      className={cx("font-sans text-xs font-normal leading-normal", className)}
      {...rest}
    >
      {children}
    </small>
  );
}
